import Axios from "axios";
import appUrl from "../../config/appUrl";
import * as consts from "../constatnts/user_constants";

const loginAdminUser = (body) => async (dispatch, getState) => {
  dispatch({ type: consts.LOGIN_USER_REQUEST });

  const url = appUrl.BASE_URL + appUrl.adminLogin;

  try {
    const { data } = await Axios.post(url, body);

    localStorage.setItem("user", JSON.stringify(data.data));
    dispatch({ type: consts.LOGIN_USER_SUCCESS, payload: data.data });
    // window.location.reload()

  } catch (error) {
    dispatch({
      type: consts.LOGIN_USER_FAILURE,
      payload:
        error.response && error.response.data.msg
          ? error.response.data.msg
          : error.message,
    });
  }
};

export { loginAdminUser };
